/*********************** Custom JS for Boost AI Search & Discovery  ************************/

const isiOS = () => {
        return /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream
}

window.addEventListener("pageshow", function(evt){
	  if(evt.persisted && isiOS()){
		  location.reload();
	}
}, false);
